"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { useCallback, useLayoutEffect, useRef, useState } from "react";
import { useComment } from "@/components/Comment/context/comment.context";
import { Translation } from "@/components/Translation/Translation.component";
export function CommentContent() {
  const $ = _c(18);
  const {
    comment: t0
  } = useComment();
  const {
    replyToAuthor,
    content
  } = t0;
  const ref = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const el = ref.current;
      if (el) {
        setIsClamped(el.scrollHeight > el.clientHeight);
      }
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useLayoutEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsExpanded(_temp);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const toggle = t3;
  let t4;
  if ($[3] !== replyToAuthor) {
    t4 = replyToAuthor ? <span className="mr-1 font-bold text-primary">@{replyToAuthor}</span> : null;
    $[3] = replyToAuthor;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const mention = t4;
  const t5 = !isExpanded && "line-clamp-3";
  const t6 = isClamped && !isExpanded && "relative after:pointer-events-none after:absolute after:inset-x-0 after:bottom-0 after:h-4 after:bg-linear-to-t after:from-silent after:to-transparent";
  let t7;
  if ($[5] !== t5 || $[6] !== t6) {
    t7 = clsx("prose wrap-anywhere max-w-full whitespace-pre-wrap text-charcoal", t5, t6);
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== content || $[9] !== mention || $[10] !== t7) {
    t8 = <p className={t7} ref={ref}>{mention}{content}</p>;
    $[8] = content;
    $[9] = mention;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== isClamped || $[13] !== isExpanded) {
    t9 = isClamped ? <button aria-expanded={isExpanded} className="mt-1 font-medium text-primary text-xs hover:underline focus-visible:underline focus-visible:outline-none" onClick={toggle} type="button">{isExpanded ? <Translation da="Vis mindre" de="Weniger anzeigen" en="Show less" no="Vis mindre" sv="Visa mindre" /> : <Translation da={"L\xE6s mere"} de="Mehr lesen" en="Read more" no="Les mer" sv={"L\xE4s mer"} />}</button> : null;
    $[12] = isClamped;
    $[13] = isExpanded;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <div className="flex flex-col items-start">{t8}{t9}</div>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}
function _temp(prev) {
  return !prev;
}